// Claude: Custom toast wrapper — light colors, small font, no bold, centered position 17-02-2026
import { useToast } from "@chakra-ui/react";
import React from "react";

export const useToastWrapper = () => {
  const toast = useToast();

  const show = (title: string, description: string | undefined, bg: string, color: string) => {
    toast({
      position: "top",
      duration: 4000,
      isClosable: true,
      containerStyle: {
        marginTop: "40vh",
      },
      render: ({ onClose }) =>
        React.createElement(
          "div",
          {
            onClick: onClose,
            style: {
              background: bg,
              color: color,
              padding: "10px 18px",
              borderRadius: "8px",
              fontSize: "13px",
              fontWeight: 400,
              textAlign: "center" as const,
              cursor: "pointer",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            },
          },
          title + (description ? " — " + description : "")
        ),
    });
  };

  return {
    success: (title: string, description?: string) => {
      show(title, description, "#D4EDDA", "#155724");
    },
    error: (title: string, description?: string) => {
      show(title, description, "#F8D7DA", "#721C24");
    },
    info: (title: string, description?: string) => {
      show(title, description, "#D1ECF1", "#0C5460");
    },
  };
};
